export default __webpack_public_path__ + "static/times-up-fa77d13529eace52f4653e04b535fc65.wav";